<template>
  <div id="auth-form">
    <!-- <div class="main-logo"></div> -->
    <!-- <div class="underlogo-title">
      <b>Вход</b>
    </div> -->
    <div class="nav">
      <span class="active-tab">Вход</span>
      <a class="link" href="/register">зарегистрироваться</a>
    </div>
    <div class="login-form" v-if="!confirmCodeRequired">
      <div>
        <input
          type="text"
          :disabled="signInLoader"
          v-model="formData.username"
          @keyup.enter="onInputKeyUp"
          placeholder="Введите логин"
          id="usernameInput">
      </div>
      <div>
        <input
          type="password"
          :disabled="signInLoader"
          v-model="formData.password"
          @keyup.enter="onInputKeyUp"
          placeholder="Введите пароль"
          id="passwordInput">
        <span v-if="formData.password && formData.password.length > 0"
          @click="showHidePassword"
          title="Показать/скрыть пароль"
          id="toggle-password"
          toggle="#passwordInput"
          class="fa fa-fw fa-eye password-icon">👁</span>
      </div>
      <ErrorAlert v-if="errorMessage && errorMessage.length" :message="errorMessage" />
      <!-- <alert-label v-if="errorMessage && errorMessage.length"
        :closable=false
        color="red"
        textAlign="center"
        >{{errorMessage}}
      </alert-label> -->

      <div class="link-tabs">
        <a class="link reset-password-link" href="#">забыли пароль?</a>
      </div>

      <div class="button-container">
        <button
          class="btn"
          :disabled="!isFormComplete"
          @click="authorize(null)">
          <spinner v-if="signInLoader"/>Войти
        </button>
      </div>
    </div>
    <div class="login-form" v-else>
      <confirm-code-form
        ref="verify"
        :canEnterCode="confirmCodeData.canEnterCode"
        :lifetimeSeconds="confirmCodeData.expirationSeconds"
        :verifyCodeLength="confirmCodeData.confirmCodeLength"
        :loader="confirmCodeDataLoader"
        v-on:submit-code="confirmLogin"
        v-on:request-new-code="authorize"
        v-if="!signInLoader && confirmCodeRequired"
       />
    </div>
    <div class="link-tabs">
      <button class="link main-page-link" @click="gotoMainPage">перейти на главную</button>
    </div>
  </div>
</template>

<script>
import VerificationCodeInput from './verification-code-input.vue';
import ConfirmCodeForm from './ConfirmCodeForm.vue';
import AlertLabel from '../alert-label.vue';

export default {
  name: 'Authorization',
  components: {
    VerificationCodeInput,
    ConfirmCodeForm,
    AlertLabel
  },
  data: () => ({
    signInLoader: false,
    formData: {
      username: '',
      password: '',
    },
    errorMessage: '',
    confirmCodeDataLoader: true,
    confirmCodeRequired: false,
    confirmCodeData: {
      confirmCodeLength: 6,
      canEnterCode: true,
      expirationSeconds: 9999,
    },
  }),
  computed: {
    isFormComplete() {
      return !this.signInLoader && this.formData.username.length && this.formData.password.length;
    }
  },
  methods: {
    gotoMainPage() {
      this.$store.dispatch('setGuest', true);
      window.location.href = '/';
    },
    onInputKeyUp(e) {
      if (e.keyCode === 13) {
        this.authorize(null);
      }
    },
    showHidePassword(e) {
      const el = $(`#${e.target.id}`);
      el.toggleClass('fa-eye fa-eye-slash');
      const input = $(el.attr('toggle'));
      if (input.attr('type') === 'password') {
        input.attr('type', 'text');
      } else {
        input.attr('type', 'password');
      }
    },
    authorize(verifyCode) {
      this.signInLoader = true;
      this.errorMessage = '';
      const bodyData = {
        userName: this.formData.username,
        password: this.formData.password,
        code: verifyCode,
      };
      this.$http.post(`${this.$host.IdentityServiceApi}/Login`, bodyData, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: 'application/json',
        },
      }).then(
        (response) => {
          this.signInLoader = false;
          const result = response.body;
          if (result.isConfirmationCodeRequired) {
            this.showVerifyForm(result.data);
          } else if (result.token && result.token.accessToken) {
            this.$emit('authenticated', result.token);
          }
        },
        (response) => {
          if (response.body && response.body.message)
            this.errorMessage = response.body.message;
          this.signInLoader = false;
          if (this.confirmCodeRequired)
            this.$refs.verify.resetInput();
        },
      );
    },
    showVerifyForm(confirmCodeData) {
      if (confirmCodeData.displayMessage) {
        // toastr.info(confirmCodeData.displayMessage);
      }
      this.confirmCodeDataLoader = true;
      this.confirmCodeData = confirmCodeData;
      this.confirmCodeRequired = true;
      this.$nextTick(() => {
        this.confirmCodeDataLoader = false;
      });
    },
    confirmLogin(verifyCode) {
      this.confirmCodeRequired = true;
      this.$nextTick(() => {
        this.authorize(verifyCode);
      });
    },
  }
}
</script>

<style scoped src='@/assets/css/authorization.css'>
</style>